export default __webpack_public_path__ + "80293d9ca9cceb9cb67ad4614259f579.svg";